import { useEffect, useState } from "react";

export const useWidth = (): number => {
  const [width, setWidth] = useState<number>(() => {
    return typeof window !== "undefined" ? window.innerWidth : 0;
  });

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return width;
};